import React, { Component } from 'react';
import { PrjListCmp } from '../component';

import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

import Fade from 'react-reveal/Fade';

import { PhotoSwipeGallery } from 'react-photoswipe';
import 'react-photoswipe/lib/photoswipe.css';

import GoTop from '../component/GoTop';

import prjList from '../projects/projectData.json';

class Work extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      isLoaded: false,
      filterOpen: true,
      isMobile: false,
      isOpen: true,
      loadItem: 30,
      moreload: 20,
    };

    this.items = prjList;

    this.options = {
      shareButtons: [
        {
          id: 'facebook',
          label: 'Share on Facebook',
          url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}',
        },
        {
          id: 'twitter',
          label: 'Tweet',
          url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}',
        },
        {
          id: 'pinterest',
          label: 'Pin it',
          url:
            'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}',
        },
        // {id:'download', label:'Download image', url:'{{raw_image_url}}', download:true}
      ],
    };

    this.scrollHandler = this.scrollHandler.bind(this);
    this.itemLoad = this.itemLoad.bind(this);

    this.msnry = '';
  }

  //Loading ing
  componentDidMount() {
    window.scrollTo({ top: 0 });

    this.itemLoad();

    window.addEventListener('scroll', this.debounce(this.scrollHandler));
  }

  itemLoad() {
    let grid = document.querySelector('.item_wrap');

    // imagesLoaded안에서 state변경 위함
    // imagesLoaded안에서 this가 바뀌므로 this를 _this에 저장해서 사용
    let _this = this;

    // imagesLoaded / Detect when images have been loaded.
    imagesLoaded(grid, function() {
      // 로드되는 시간 동안 로딩바 노출
      _this.setState({
        isLoaded: true,
      });

      let msnry = new Masonry(grid, {
        itemSelector: '.item_card',
        percentPosition: true,
        columnWidth: '.grid-sizer',
        gutter: '.grid-gutter',
      });
    });
  }

  debounce(func, wait = 10, immediate = true) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  scrollHandler() {
    let bodyHeight = document.querySelector('body').offsetHeight;
    let winHeight = window.innerHeight;
    // let winScroll = window.scrollY;  //ie bug
    let winScroll = window.pageYOffset;
    let grid = document.querySelector('.item_wrap');

    if (
      winHeight + winScroll >= bodyHeight - 200 &&
      this.state.loadItem < this.items.length
    ) {
      this.setState({
        loadItem: this.state.loadItem + this.state.moreload,
      });
      // console.log('add load!!!', this.state.loadItem, this.items.length);

      this.setState({
        isLoaded: false,
      });

      this.itemLoad();
    }
  }

  getThumbnailContent = (item) => {
    return (
      <React.Fragment>
        {/* <img src={item.thumbnail} />
                <p>{item.type}</p>
                <p>{item.title}</p> */}

        {/* 
                React Reveal 적용 위치 주의 
                item_card가 아닌 하위 엘리먼트에 적용
                뷰페이지 뜰때 레이아웃 깨짐 방지
            */}
        <div className="item_card">
          <Fade bottom>
            <div className="card">
              <div className="img">
                <img src={item.thumbnail} />
              </div>
              <div className="cont">
                <p className="type">{item.type}</p>
                <p className="title">{item.title}</p>
              </div>
            </div>
          </Fade>
        </div>
      </React.Fragment>
    );
  };

  render() {
    return (
      <React.Fragment>
        {/* loading */}
        {this.state.isLoaded ? (
          ''
        ) : (
          <div className="loading_box">
            <span>Loading ...</span>
          </div>
        )}

        <div className="section_copy">
          <p className="cate">Gallery</p>
          <p className="desc">
            대기업 &middot; 관공서 &middot; 지역축제 다양한 곳에서 <br />
            차이나매직을 찾는 이유가 있습니다.
            {/* 변검과 마술이 어우러진 환상적인 퍼포먼스로 <span className="wbr" />{' '}
            감동적인 경험을 제공합니다. <br /> */}
          </p>
          <p className="desc2">
            {/* <span className="strong">{prjList.length}</span>장의 공연 사진이
            있습니다.
            <br /> */}
            {/* 대기업 관공서 지역축제 다양한 곳에서 차이나매직을 찾는 데는 다
            이유가 있습니다. <br /> */}
            공연 경험이 많은 오리지널 중국 전통 변검 마술공연 차이나매직과
            함께하세요. <br />
            중국 변검 마술공연 사진 무단 사용과 도용 시 법적으로 처벌받을 수
            있습니다.
            {/* 클릭하여 크게 볼 수 있으며 스크롤 하여 더 많은 사진을 볼 수
            있습니다. <br />
            중국 변검 마술공연 사진 무단 사용과 도용 시 법적으로 처벌받을 수
            있습니다. */}
          </p>
        </div>

        <div className="inner_left">
          <div className="item_wrap">
            <div className="grid-sizer" />
            <div className="grid-gutter" />

            <PhotoSwipeGallery
              items={this.items.slice(0, this.state.loadItem)}
              options={this.options}
              thumbnailContent={this.getThumbnailContent}
            />
          </div>

          <div className="btn_wrap">
            <a className="btn action" href="tel:010-8888-8084" target="_blank">
              010 - 8888 - 8084
            </a>
          </div>
        </div>

        <GoTop />
      </React.Fragment>
    );
  }
}

export default Work;
